import { Title, desktopFirstMediaQuery } from '@inflearn/ds-react';
import React from 'react';

type Props = {
  children: string;
};

const SessionTitle = ({ children }: Props) => {
  return (
    <Title
      mb={12}
      order={1}
      color="gray.9"
      css={{
        fontSize: '32px',
        lineHeight: '1.4',
        [desktopFirstMediaQuery.mobile]: {
          fontSize: '24px'
        }
      }}>
      {children}
    </Title>
  );
};

export default SessionTitle;
